import React from 'react';
import styles from './TextMessageCard.module.css';

export default function TextMessageCard({ text, senderName, timestamp }) {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <span className={styles.sender}>{senderName}</span>
        <span className={styles.time}>{new Date(timestamp).toLocaleTimeString()}</span>
      </div>
      <div className={styles.body}>{text}</div>
    </div>
  );
}
